import { render } from "./ShowcaseZaymelo.vue?vue&type=template&id=0a3635ae"
import script from "./ShowcaseZaymelo.vue?vue&type=script&lang=js"
export * from "./ShowcaseZaymelo.vue?vue&type=script&lang=js"

import "./ShowcaseZaymelo.vue?vue&type=style&index=0&id=0a3635ae&lang=css"
import "./ShowcaseZaymelo.vue?vue&type=style&index=1&id=0a3635ae&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-showcase/leadsbroker-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__